import { Typography } from "antd";

import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import { VoiceAIFormItemKeys } from "../../../../Components/JourneyActionsPanel/NodeEditorPanel/Components/_DemoFormItems/constants";
import { useJourneyBlockData } from "../../Shared/Hooks/useJourneyBlockData/useJourneyBlockData";

import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";

import iconStyles from "./iconfix.module.scss";

const BLOCK_TITLE = "Regal AI Action";
const NODE_TITLE = "AI Phone Agent";
const NODE_PROMPT = "Select Voice Agent";

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.DEMO_VoiceAI).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.DEMO_VoiceAI);

export function VoiceAIBlock({ data, variant }: SharedBlockProps): JSX.Element {
    const { [VoiceAIFormItemKeys.voiceAIName]: name } = data || {};

    const isNodeConfigured = !!name;

    const preferedNodeName = `${name}`;

    const { fallBackTitle, isActive, nodeName } = useJourneyBlockData({
        variant,
        isNodeConfigured,
        preferedNodeName,
        blockTitle: BLOCK_TITLE,
        nodeTitle: NODE_TITLE,
        nodePropmpt: NODE_PROMPT,
    });

    return (
        <BlockContainer iconClassName={iconStyles.outgoingFix} variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={fallBackTitle}></BlockTitle>

            <BlockContent isActive={isActive}>
                <Typography.Text>{nodeName}</Typography.Text>
            </BlockContent>
        </BlockContainer>
    );
}
